<template>
  <v-row>
    <v-col xs12 md12>
      <div class="headline">Aufträge</div>
      <v-card>
        <v-card-title>
          <v-select
            :items="tour"
            item-value="id"
            v-model="search.tour"
            append-icon="far fa-clipboard-list"
            label="Tour auswählen"
            single-line
            hide-details
            :clearable="true"
            @change="changeTour()"
          >
            <template slot="selection" slot-scope="data">
              <v-row style="width: 100%">
                <v-col cols="1"><TourID :tour="data.item"></TourID></v-col>
                <v-col cols="2" class="align-self-center">{{ data.item.date }}</v-col>
                <v-col cols="7" class="align-self-center">{{ data.item.name }}</v-col>
                <v-col cols="2"><TourWorkload :tour="data.item"></TourWorkload></v-col>
              </v-row>
            </template>
            <template slot="item" slot-scope="data">
              <v-row style="width: 100%">
                <v-col cols="1"><TourID :tour="data.item"></TourID></v-col>
                <v-col cols="2" class="align-self-center">{{ data.item.date }}</v-col>
                <v-col cols="7" class="align-self-center">{{ data.item.name }}</v-col>
                <v-col cols="2"><TourWorkload :tour="data.item"></TourWorkload></v-col>
              </v-row>
            </template>
          </v-select>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search.name"
            append-icon="far fa-search"
            label="Suchen"
            single-line
            hide-details
            :clearable="true"
            @change="updateSearch"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="tables.duties.header"
          :items="duties"
          :search="search.name"
          :items-per-page="15"
          class="mb-4"
          :multi-sort="true"
        >
          <template v-slot:item.created="{ item }">
            {{ item.createdDate }}
          </template>
          <template v-slot:item.lastChange="{ item }">
            {{ item.lastChangeDate }}
          </template>tourTemplate
          <template v-slot:item.streetName="{ item }">
            {{ item.streetName }} {{ item.streetNumber }}
          </template>
          <template v-slot:item.tourTemplate="{ item }">
            <TourID :tour="getTour(item.tour)" v-if="item.tourTemplate > 0"></TourID>
          </template>
          <template v-slot:item.email="{ item }">
            <v-btn icon text :to="{ name: 'duty', params: { id: item.id }}"><v-icon>far fa-edit</v-icon></v-btn>
          </template>
          <template v-slot:item.tour="{ item }">
          </template>
        </v-data-table>
      </v-card>
      <v-btn color="green" :to="{name: 'duty', params: {id: 0}}">Grüne Karte erfassen</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import TourID from './TourID'
import TourWorkload from './TourWorkload'

export default {
  name: 'Duties',
  components: {TourID, TourWorkload},
  props: ['id'],
  computed: {
    duties: function () {
      let duties = [...this.$store.state.duties.all]
      if (this.search.tour > 0) {
        duties = duties.filter(duty => duty.tour === this.search.tour)
      }
      return duties.reverse()
    },
    tour () {
      return this.$store.state.tour.all
    },
    cities () {
      return this.$store.state.cities.all
    },
    districts () {
      return this.$store.state.districts.all
    },
    streets () {
      return this.$store.state.streets.all
    }
  },
  methods: {
    changeTour () {
      this.updateSearch()
      if (this.search.tour > 0) {
        this.$router.push({
          name: 'duties',
          params: {
            id: this.search.tour
          }
        }).catch()
      } else {
        this.$router.push({
          name: 'duties'
        }).catch()
      }
    },
    getCity (id) {
      return this.cities.find(element => element.id === id)
    },
    getStreet (id) {
      return this.streets.find(element => element.id === id)
    },
    getTourTemplate (id) {
      return this.tour.find(tour => tour.id === id).template
    },
    getTour (id) {
      let tour = this.tour.find(tour => tour.id === id)
      if (tour !== undefined) {
        return tour
      }
      return {}
    },
    getColor (identifier) {
      if (identifier !== undefined) {
        return this.$store.state.tourTemplate.all.find(tour => tour.identifier === identifier).color
      }
      return ''
    },
    updateSearch () {
      this.$store.dispatch('updateDuties', this.search)
    }
  },
  data: () => ({
    search: {
      tour: 0,
      name: ''
    },
    searchTourValue: 0,
    tables: {
      duties: {
        header: [
          {text: 'Erstelldatum', value: 'created'},
          {text: 'Änderungsdatum', value: 'lastChange'},
          {text: 'Vorname', value: 'firstname'},
          {text: 'Nachname', value: 'lastname'},
          {text: 'Straße', value: 'streetNameAndNumber'},
          {text: 'Ort', value: 'cityAndDistrict'},
          {text: 'Tour', value: 'tourTemplate'},
          {text: '', sortable: false, value: 'email'}
        ]
      }
    }
  }),
  created () {
    if (this.id > 0) this.search.tour = this.id
    this.updateSearch()
    this.search = this.$store.state.search
  }
}
</script>

<style scoped lang="scss">
    @import "../scss/settings";

    .md-table {
        margin-bottom: 1rem;
    }

    .action.md-icon {
        color: $primary-color;
    }

    .city {
        display: inline-block;
        padding-right: 0.75rem;
    }

    .nearlyFull {
        color: orange;
    }

    .full {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/components/Duties.vue